<template>
  <div class="line-chart-panel">
    <div class="line-chart" ref="lineChartProvince" />
  </div>
</template>

<script>
let self
const echarts = require('echarts')
import moment from 'moment'
export default {
  name: 'LineChart',
  props: {
    lineData: {
      default: () => [],
    },
    detector: {},
  },
  data() {
    return {
      myChart: '',
    }
  },
  watch: {
    lineData() {
      if (!this.lineData) return
      if (!this.myChart) {
        this.drawLine()
      } else {
        this.myChart.setOption(this.getOption())
      }
    },
  },
  mounted() {
    self = this
    this.drawLine()
  },
  methods: {
    moment,
    drawLine() {
      // if(!this.lineData) return
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.lineChartProvince)
      // 绘制图表
      let option = this.getOption()
      this.myChart.setOption(option)
    },
    getOption() {
      let option = {
        title: {
          text:
            this.lineData.length === 0
              ? '暂无数据'
              : `${this.detector.number}号 ${
                  this.detector.mountingPosition
                    ? `（${this.detector.mountingPosition}）`
                    : ''
                }`,
          left: 'center',
          textStyle: {
            color: 'rgb(209, 195, 39)',
            fontSize: '15',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false,
          },
          textStyle: {
            fontSize: 10,
          },
        },
        grid: {
          top: '6%',
          left: '10%',
          right: '10%',
          bottom: '8%',
          containLabel: true,
        },
        dataZoom: [
          {
            show: true,
            height: 25,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon:
              'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '110%',
            handleStyle: {
              color: '#d3dee5',
            },
            textStyle: { color: '#444' },
            borderColor: '#90979c',
          },
          {
            type: 'inside',
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        xAxis: {
          type: 'time',
          boundaryGap: false,
          axisLabel: {
            // rotate: 45,
            textStyle: {
              fontSize: 12,
              color: '#888888',
            },
            lineHeight: 15,
            formatter: function (value) {
              return `${moment(value).format('YYYY-MM-DD')}\n${moment(
                value
              ).format('HH:mm:ss')}`
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#00CCFF',
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: '#888888',
            },
          },
          splitNumber: 10,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: '#888888',
            },
            lineHeight: 15,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#00CCFF',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#EEEEED',
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: 'line',
            smooth: false,
            // symbol:'emptydiamond',
            data: this.lineData,
            itemStyle: {
              normal: { color: 'rgba(133, 186, 237)' }, //折线图颜色
            },
            label: {
              show: false,
              position: 'bottom',
              color: '#fff',
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(133, 186, 237, 1)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(133, 186, 237,0)',
                  },
                ],
                globalCoord: false,
              },
            },
          },
        ],
      }
      return option
    },
  },
}
</script>

<style scoped>
.line-chart-panel {
  text-align: center;
  width: 100%;
  height: 100%;
}
.line-chart {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/views/bigscreen/monitor/LineComponent.vue